import { Grid, linearProgressClasses, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useCallback, useEffect, useState } from "react";
import EnvService from "../../../services/env.service";
import UrlService from "../../../services/url.service";
import Styles from './oauth-login-msal-style';
import CredentialSVG from "../../../assets/images/credential.svg";
import { LinearProgress, styled } from "@material-ui/core";

const ENDPOINT_MSAL_SIGNIN = "msal/signin";
const BG_COLOR = '#F0F2F4';

const BorderLinearProgress = styled(LinearProgress)(({ _theme }) => ({
  height: 4,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: BG_COLOR,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#3853FF',
  },
}));

export function OauthLoginMSAL() {
  const { REACT_APP_OAUTH_APW_ROUTE_URL } = EnvService.getEnv();
  const redirectAppUrl = UrlService.getQueryString("redirect_app_url");
  const currentUrl = window.location.href;

  const styles = Styles();

  const [progressPercentage, setProgressPercentage] = useState(0);

  const handleLoginMSAL = useCallback (async () => {
    if (REACT_APP_OAUTH_APW_ROUTE_URL){
      localStorage.setItem('msal_web_url', currentUrl);
      window.location = `${REACT_APP_OAUTH_APW_ROUTE_URL}/${ENDPOINT_MSAL_SIGNIN}?redirect_app_url=${redirectAppUrl}`;
      return;
    }

    throw new Error("env not found.");    
  },[REACT_APP_OAUTH_APW_ROUTE_URL, redirectAppUrl, currentUrl]);

  const startRedirectTimer = useCallback (()=>{
    let initialTime = 4;
    let timeLeft = 0;

    let interval = setInterval(()=>{
      timeLeft++;

      setProgressPercentage((timeLeft / initialTime)  * 100);
  
      if(timeLeft >= initialTime) {
        clearInterval(interval);
        handleLoginMSAL();
      }
    }, 1000);
  }, [handleLoginMSAL]);
  
  useEffect(startRedirectTimer, [startRedirectTimer]);

  useEffect(() => {
    document.body.style.backgroundColor = BG_COLOR;
  }, []);

  return (
    <Box>
      <Grid container 
        justifyContent="center"
        alignItems="center"
        >
        <Grid container
          className={styles.container}
          direction="column"
          md={4}
          alignItems="center"
          spacing={2}
        >
          <Grid item>
            <img src={CredentialSVG} alt="" />
          </Grid>
          <Grid item style={{width: '100%', paddingRight: 50}}>
            <BorderLinearProgress variant="determinate" value={progressPercentage} style={{top:0}}/>
          </Grid>
          <Grid item style={{textAlign: 'left', width: '100%'}} >
            <Typography variant="h4" style={{fontFamily: 'BancoDoBrasil Titulos'}}>
              Vamos te redirecionar para fazer login com segurança
            </Typography>
          </Grid>
          <Grid item >
            <Typography style={{textAlign: 'left'}}>
              Estamos encaminhando você para o ambiente de autenticação da Microsoft (MSAL). Esse processo é automático, seguro e garante o acesso com sua conta corporativa.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
